import styled from "@emotion/styled";
import { css, Typography } from "@mui/material";
import { mobile } from "commons/styled.components";
import Button from "components/button";

export const Wrapper = styled.div`
  padding: 1.8rem;

  ${mobile(css`
    padding: 1rem;
    padding-bottom: 2rem;
  `)}
`;

export const TableWrapper = styled.div`
  min-width: 750px;

  ${mobile(css`
    min-width: 0px;
  `)}
`;

export const ContentWrapper = styled.div`
  white-space: nowrap;
  overflow-x: auto !important;
  width: 100% !important;

  &::-webkit-scrollbar-thumb {
    background: #909090;
    border-radius: 8px;
    cursor: pointer;
  }
`;

export const LoaderWrapper = styled.div`
  min-height: 150px;
`;

export const DialogContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 60px 60px 20px 60px;
  gap: 24px;
  align-items: center;
`;

export const PurchaseSuccessText = styled(Typography)`
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 500;
`;

export const GoToSurveysButton = styled(Button)`
  width: fit-content;
`;

/* Survey Profiler Styles */

export const SurveyProfileMainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const RewardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(264px, 1fr));
  gap: 24px;
`;

export const RewardsTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  padding: 1.8rem;
`;

export const RewardContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const CategoryText = styled(Typography)`
  /* Choose a category and answer questions to unlock more qualifying surveys */

  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #727272;
  width: 50%;

  ${mobile(css`
    width: 100%;
  `)}
`;

export const RewardText = styled(Typography)`
  /* Get 2 coins for every 10 question* */

  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  color: #000000;
`;

export const CoinIcon = styled.img`
  height: 24px;
  width: 24px;
`;
